import { render } from "./BonModal.vue?vue&type=template&id=3b2bec4a&scoped=true"
import script from "./BonModal.vue?vue&type=script&lang=js"
export * from "./BonModal.vue?vue&type=script&lang=js"

import "./BonModal.vue?vue&type=style&index=0&id=3b2bec4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2bec4a"]])

export default __exports__